var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProposeChange({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.726562 9.45459V15.2727",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.726562 14.303H10.4234C10.4234 13.232 9.5551 12.3637 8.48402 12.3637H6.05981C6.05981 11.2926 5.19153 10.4243 4.12045 10.4243H0.726562",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12109 12.3638H6.06046",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7666 10.1667C12.0507 10.5404 12.4994 10.7519 12.9684 10.733C13.7041 10.733 14.3014 10.285 14.3014 9.73231C14.3014 9.17959 13.7041 8.73289 12.9684 8.73289C12.2327 8.73289 11.6348 8.2849 11.6348 7.73218C11.6348 7.17946 12.2321 6.73211 12.9684 6.73211C13.4369 6.71333 13.8851 6.9245 14.1689 7.29776",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9688 10.7329V11.3988",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9688 6.06543V6.73192",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93892 8.97432H7.41775C7.18257 8.97075 6.95845 8.87384 6.79476 8.70493C6.63107 8.53603 6.54124 8.30898 6.54504 8.07381V3.5719C6.53748 3.08228 6.92814 2.67918 7.41775 2.67139H14.3995C14.8891 2.67918 15.2797 3.08228 15.2722 3.5719V6.06527",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45312 2.67153V2.00503C9.50666 1.25356 10.1557 0.685569 10.9076 0.732166V0.732166C11.6596 0.685569 12.3086 1.25356 12.3622 2.00503V2.67153",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProposeChange);
export default __webpack_public_path__ + "static/media/ProposeChange.6872cd6be4684f425e8b25d801075279.svg";
export { ForwardRef as ReactComponent };